module.exports = __webpack_public_path__ + "components/weather-icon/static/nightclear-9c3602b6b2516286e07754baa7378df3.webp";